import React from 'react';
import { createPortal } from 'react-dom';

// Dialog di gestione agenti: per ogni agente un interruttore attivo/disattivo,
// il suo stato (attivo / in attesa / spento / disservizio) e i pulsanti Priorità
// (ed eventuale Fascia oraria per SSMATE). Aperto dall'icona impostazioni del dock.
function Switch({ on, color, disabled, onClick }) {
  return (
    <button type="button" onClick={onClick} disabled={disabled} aria-pressed={on}
      style={{
        width: 46, height: 26, borderRadius: 20, border: '1px solid ' + (on ? color : '#cbd5e1'),
        background: on ? color : '#e2e8f0', position: 'relative', cursor: disabled ? 'default' : 'pointer',
        padding: 0, flex: '0 0 auto', opacity: disabled ? 0.6 : 1, transition: 'background .2s, border-color .2s',
      }}>
      <span style={{
        position: 'absolute', top: 2, left: on ? 22 : 2, width: 20, height: 20, borderRadius: '50%',
        background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,.25)', transition: 'left .2s',
      }} />
    </button>
  );
}

const stColor = { attivo: '#16a34a', 'in attesa': '#d97706', disservizio: '#dc2626', spento: '#94a3b8' };

export default function AgentiManagerDialog({ open, onClose, items = [], busy, onToggle, onPriority, onScheduling, onOpzioni }) {
  if (!open) return null;
  return createPortal(
    <div className="nt-overlay" onClick={onClose} style={{ zIndex: 11000 }}>
      <div className="nt-detail nt-fume" style={{ width: '96vw', maxWidth: 520, maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }} onClick={(e) => e.stopPropagation()}>
        <div className="nt-detail-head"><span>Gestione agenti</span><button className="ob-x" onClick={onClose}>✕</button></div>
        <div className="nt-detail-body" style={{ background: '#f5f7fb', overflow: 'auto', flex: 1, padding: 14, display: 'flex', flexDirection: 'column', gap: 10 }}>
          {items.map((it) => (
            <div key={it.key} style={{ background: 'var(--surface)', border: '1px solid #e8edf3', borderRadius: 12, boxShadow: '0 1px 3px rgba(15,23,42,.06)', padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={{ width: 38, height: 38, borderRadius: 10, flex: '0 0 auto', display: 'grid', placeItems: 'center', color: it.on ? '#fff' : '#94a3b8', background: it.on ? it.color : '#eef2f7', boxShadow: it.on ? `0 0 0 1px ${it.color}` : 'none' }}>
                {it.icon}
              </span>
              <div style={{ minWidth: 0, flex: 1 }}>
                <div style={{ fontWeight: 700, fontSize: 14 }}>{it.label}</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2 }}>
                  <span style={{ width: 7, height: 7, borderRadius: '50%', background: stColor[it.statusLabel] || '#94a3b8' }} />
                  <span style={{ fontSize: 12, color: stColor[it.statusLabel] || '#64748b', fontWeight: 600, textTransform: 'capitalize' }}>{it.statusLabel}</span>
                </div>
              </div>
              {it.hasScheduling && (
                <button type="button" className="btn btn-secondary btn-sm" style={{ fontSize: 12, padding: '5px 9px' }} onClick={onScheduling} title="Fascia oraria">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
                </button>
              )}
              {it.hasOpzioni && (
                <button type="button" className="btn btn-secondary btn-sm" style={{ fontSize: 12, padding: '5px 9px' }}
                        onClick={() => onOpzioni(it.key)} title="Parametri dell'agente (ritmo e fasce orarie)">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9c.2.62.77 1.03 1.42 1.03H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></svg>
                </button>
              )}
              {it.hasPriority && (
                <button type="button" className="btn btn-secondary btn-sm" style={{ fontSize: 12, padding: '5px 10px', display: 'inline-flex', alignItems: 'center', gap: 6 }} onClick={() => onPriority(it.key)}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="5" y1="19" x2="5" y2="14" /><line x1="12" y1="19" x2="12" y2="9" /><line x1="19" y1="19" x2="19" y2="4" /></svg>
                  Priorità
                </button>
              )}
              <Switch on={it.on} color={it.color} disabled={busy} onClick={() => onToggle(it.toggleUrl, !it.on, it.nome)} />
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
}
